import { heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20energetic%20orange%20and%20crimson%20gradient%20waves%20with%20glowing%20particles%20over%20deep%20warm%20dark%20background%2C%20stylized%20digital%20art%2C%20dramatic%20light%20streaks%2C%20high%20contrast%20editorial%20energy%2C%20soft%20film%20grain&width=1600&height=900&seq=hero-51cg5-a1&orientation=landscape"
          alt="51cg5 热门榜与实时热度追踪视觉背景"
          title="51cg5 热门榜与实时热度追踪"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/60 to-foreground-950/85"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-[1440px] flex-col items-center px-4 pb-24 pt-16 text-center md:px-6 md:pb-32 md:pt-24">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs font-bold tracking-wide text-background-50 backdrop-blur">
          <span className="flex h-4 w-4 items-center justify-center text-primary-300">
            <i className="ri-fire-fill"></i>
          </span>
          实时热度追踪 · 热门榜持续更新
        </span>

        <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-background-50 sm:text-5xl md:text-7xl">
          51cg5 热门榜
        </h1>
        <p className="mt-5 max-w-3xl text-sm leading-relaxed text-background-100/90 md:text-lg">
          打开 51cg5，实时查看热门话题榜与热度追踪，快速掌握话题排行与热议焦点，随时跟进当前最受关注的事件动态。
        </p>

        <div className="mt-8 w-full max-w-2xl">
          <div className="flex flex-col items-stretch gap-2 rounded-2xl border border-background-50/20 bg-background-50/10 p-2 backdrop-blur sm:flex-row sm:items-center sm:rounded-full">
            <span className="hidden h-6 w-6 items-center justify-center pl-2 text-background-100/80 sm:flex">
              <i className="ri-search-eye-line text-lg"></i>
            </span>
            <input
              placeholder="输入想追踪的话题关键词"
              className="min-w-0 flex-1 bg-transparent px-4 py-2.5 text-sm text-background-50 outline-none placeholder:text-background-100/60"
            />
            <button
              type="button"
              className="shrink-0 cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              立即追踪热度
            </button>
          </div>
        </div>

        <div className="mt-10 grid w-full max-w-3xl grid-cols-3 gap-3 md:gap-5">
          {heroStats.map((stat) => (
            <div key={stat.label} className="rounded-xl border border-background-50/15 bg-background-50/10 px-3 py-4 backdrop-blur">
              <div className="font-heading text-xl font-black text-background-50 md:text-3xl">{stat.value}</div>
              <div className="mt-1 text-xs text-background-100/80 md:text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}